export const INTERVIEW_ROUND_ADD = 'INTERVIEW_ROUND_ADD'
export const INTERVIEW_ROUND_ALL = 'INTERVIEW_ROUND_ALL'
export const INTERVIEW_ROUND_REQUEST = 'INTERVIEW_ROUND_REQUEST'
export const INTERVIEW_ROUND_RESET = 'INTERVIEW_ROUND_RESET'
export const INTERVIEW_ROUND_FAILD = 'INTERVIEW_ROUND_FAILD'

